import React from 'react';
import styled from 'styled-components';
import { Sidebar as ProSidebar } from 'react-pro-sidebar';

import logoFull from '../../assets/media/flexbee-no-bg-dark.webp';
import logoIcon from '../../assets/media/bee-dark-1024.png';
import { SIDEBAR_WIDTH, SIDEBAR_COLLAPSED } from './shellMetrics';

const LogoArea = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  min-height: 72px;
  border: none;
  background: none;
  cursor: pointer;
  border-bottom: 1px solid #E8ECF0;
  transition: background 0.15s;
  width: 100%;
  flex-shrink: 0;

  &:hover {
    background: ${({ theme }) => theme.colors.bgColor};
  }
`;

const LogoFull = styled.img`
  height: 36px;
  width: auto;
  object-fit: contain;
`;

const LogoSmall = styled.img`
  height: 36px;
  width: 36px;
  object-fit: contain;
`;

// Geriye dönük uyum: bu iki sabit uzun süredir Sidebar'dan dışa veriliyordu.
// Tanımları shellMetrics.js'e taşındı (kabuğun tek kaynağı), ama dışa verim
// burada da korunuyor ki mevcut içe aktarımlar kırılmasın.
export { SIDEBAR_WIDTH, SIDEBAR_COLLAPSED };

/**
 * @param {boolean} collapsed     Masaüstünde daraltılmış (72px) mod.
 * @param {Function} onToggle     Logoya tıklayınca daraltmayı çevirir.
 * @param {boolean} offCanvas     FE-08: dar ekranda kenar çubuğu içeriğin
 *                                ÜSTÜNE binen bir katman olur, yer kaplamaz.
 * @param {boolean} open          off-canvas modda görünür mü.
 */
export default function Sidebar({ collapsed, onToggle, offCanvas = false, open = false, children }) {
  // Off-canvas modda "daraltılmış" mod anlamsız: kenar çubuğu zaten gizli,
  // görünürken de tam genişlikte olmalı (72px'lik ikon şeridi telefonda
  // dokunma hedefi olarak da, okunurluk olarak da işe yaramaz).
  const effectiveCollapsed = offCanvas ? false : collapsed;

  return (
    <ProSidebar
      collapsed={effectiveCollapsed}
      width={`${SIDEBAR_WIDTH}px`}
      collapsedWidth={`${SIDEBAR_COLLAPSED}px`}
      backgroundColor="#fff"
      transitionDuration={250}
      rootStyles={{
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        height: '100vh',
        borderRadius: '0 6px 6px 0',
        boxShadow: '0 4px 24px rgba(0, 66, 66, 0.08)',
        border: 'none',
        // Off-canvas katmanı perdenin (1099) üstünde durmalı.
        zIndex: offCanvas ? 1100 : 100,
        // Kapalıyken tamamen ekran dışına kayar. `visibility` ekstra bir
        // güvence: `translateX(-100%)` sonrası öğe hâlâ odaklanabilir
        // olduğundan, klavye kullanıcısı görünmeyen menüde kaybolurdu.
        transform: offCanvas && !open ? `translateX(-${SIDEBAR_WIDTH}px)` : 'translateX(0)',
        visibility: offCanvas && !open ? 'hidden' : 'visible',
        transition: 'transform 0.25s ease, visibility 0.25s ease',
        '.ps-sidebar-container': {
          background: '#fff',
          display: 'flex',
          flexDirection: 'column',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        },
        '.ps-sidebar-container::-webkit-scrollbar': {
          display: 'none',
          width: 0,
          height: 0,
        },
      }}
    >
      <LogoArea onClick={onToggle}>
        {effectiveCollapsed ? (
          <LogoSmall src={logoIcon} alt="Flexbee" />
        ) : (
          <LogoFull src={logoFull} alt="Flexbee" />
        )}
      </LogoArea>
      {children}
    </ProSidebar>
  );
}
